import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Link } from '@alfa-bank/site-link';
import { createWidget } from '@alfa-bank/site-util-create-widget';
import { BigArrowLeftLineMIcon as LinkIcon } from '@alfalab/icons-glyph/BigArrowLeftLineMIcon';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { YandexSearchBar as SearchBar } from '@alfa-bank/site-yandex-search/search-bar-desktop';
import { ViewAnalytics } from '@alfa-bank/site-view-analytics';
import { BlockDesktop } from '@alfa-bank/site-block/desktop';

import { SectionLinkDesktop as SectionLink } from '../components/section-link/desktop';
import { SubSectionDesktop as SubSection } from '../components/sub-section/desktop';
import type { IDepsDesktop, TSeoBlockDesktop } from '../models';

import { SeoBlock as Component } from './seo-block';
import styles from './desktop.css';

export const SeoBlockDesktop = createWidget<IDepsDesktop, TSeoBlockDesktop>({
    styles,
    Layout,
    Text,
    Link,
    SectionLink,
    LinkIcon,
    Button,
    SearchBar,
    SubSection,
    BlockDesktop,
    ViewAnalytics,
})(Component);
